import { StaticImage } from "gatsby-plugin-image"

import { blogUrl } from "../../services/blogLinks"
// Assuming these imports are still needed for the component structure
import LinkedInIcon from "../../images/case-study/ugc/linkedin.svg"
import icon1 from "../../images/svg/1.svg"
import icon2 from "../../images/svg/2.svg"
import icon3 from "../../images/svg/3.svg"
import icon4 from "../../images/svg/4.svg"
import { info } from "console"
import { title } from "process"
import { ImagePositions } from "./CaseStudy"

const africanTechSummit = {
  color: "#e5eeff",
  heroTitle: `African Tech Summit Hit a 50% Advocacy Rate — 10x the Industry Average
`,
  heroImage: (
    <StaticImage
      src="../../images/case-study/african-tech-summit/hero.png"
      alt="gitex-global-dubai-tech-conference-photo-ai-hero"
    />
  ),
  metrics: {
    title: "Background",
    content: `Most events struggle to get even 1 in 20 attendees to share anything online. African Tech Summit flipped the script:<br/><br/><ul style='list-style: disc; padding-left: 18px;'>
  <li><b>218 attendees</b> turned into active promoters</li>
  <li><b>600 unique clicks</b> came from attendee shares</li>
  <li><b>50% advocacy rate</b> (vs. 5% industry standard)</li>
</ul><br/>That’s <b>10x higher than the industry average</b> and proof that attendee-driven promotion doesn’t have to be an afterthought.`,
  },
  images: [
    {
      //   img: (
      //     <StaticImage
      //       src="../../images/case-study/gitex-global-2025/banner.png"
      //       alt="gitex-global-dubai-tech-conference-photo-ai-primary-banner"
      //     />
      //   ),
    },
  ],
  //   gallery: (
  //     <StaticImage
  //       src="../../images/case-study/gitex-global-2025/gallery.png"
  //       alt="gitex-global-dubai-tech-conference-photo-ai-gallery"
  //     />
  //   ),
  caseStudyData: [
    {
      title: "Introduction",
      info1: `<a href='https://www.africatechsummit.com/'>African Tech Summit</a> is one of the continent’s leading technology gatherings, held annually in Nairobi and London. It brings together over 1,000 attendees, 450+ companies, and 150 speakers—connecting startups, investors, and corporates shaping Africa’s tech ecosystem.`,
      image: (
        <StaticImage
          src="../../images/case-study/gitex-global-2025/first.png"
          alt="gitex-global-dubai-tech-conference-photo-ai-introduction"
          className="w-full h-96"
        />
      ),
    },
    {
      title: "The Challenge",
      info1: `<b>Stuck at less than 10% attendee participation</b><br/><br/>You know the frustration: You spend months planning an incredible event, but when it comes to getting attendees to actually talk about it, you're lucky if 1 in 20 shares anything meaningful.<br/><br/>Industry benchmarks and event technology reports tell the story:<br/><br/> <ul style='list-style-type:disc; padding-left:28px;margin:0;display:flex;flex-direction:column;gap:16px;'>
  
  <li>
    <span>
      Attendee-generated content typically accounts for 
      <b>less than 10% of total participation</b> 
      at many industry events.
    </span>
    <a 
      href='https://blog.walls.io/statistics/ugc-events-statistics/' 
    >
      Source
    </a>
  </li>

  <li>
    <span>
      <b>Organizers are forced to spend more on paid ads</b> 
      to compensate.
    </span>
  </li>

  <li>
    <span>
      <b>92% of event teams</b> are actively focused on post-event engagement strategies,
      but authentic attendee sharing remains challenging.
    </span>
    <a 
      href='https://www.bizzabo.com/blog/event-marketing-statistics' 
    >
      Source
    </a>
  </li>

</ul><br/>Despite being one of Africa’s leading tech gatherings, the African Tech Summit was no exception. Their advocacy numbers were flat, ROI was difficult to justify, and traditional referral tools weren’t delivering. They needed a new approach.
`,
    },
    {
      title: "The Solution",
      subheading: "Premagic’s event marketing posters",
      info1: `
  <p>
    To solve this, African Tech Summit partnered with 
    <b>Premagic</b>, introducing a fresh way to make attendee advocacy both effortless and rewarding.
  </p>

  <p>
    <b>Here’s how the experience worked in practice:</b>
  </p>
        <br/>
  <ul style='list-style-type:disc; padding-left:28px;margin:0 0 20px 0;display:flex;flex-direction:column;gap:12px;'>

    <li>
      <b>Personalized, branded poster templates</b> were created easily using Premagic’s poster maker.
    </li>

    <li>
      <b>A single share link</b> was generated and sent to all attendees, who simply had to click to access their poster, instantly furnished with their photo, name, and designation.
    </li>

    <li>
      Each poster was paired with <b>AI-powered captions</b> that made sharing effortless. Attendees could even regenerate the captions until the wording matched their personal tone.
    </li>

    <li>
      With <b>one-click publishing</b>, posters could be shared instantly across LinkedIn, Instagram, X, Facebook, WhatsApp, and more.
    </li>

    <li>
      On the backend, organizers had access to a <b>live dashboard</b> tracking shares, advocates, poster clicks, and engagement in real time.
    </li>

  </ul>

  <p>
    For attendees, it was simple and fun. For the organizing team, it was fully automated and measurable.
  </p>`,
      CTA: {
        text: "Learn how to create and share Premagic Event Marketing Posters",
        link: "https://www.youtube.com/watch?v=tNNJ1gYnXjA",
        position: "bottom",
      },
      //   image: (
      //     <StaticImage
      //       src="../../images/case-study/gitex-global-2025/one-platform.png"
      //       alt="gitex-global-dubai-tech-conference-photo-ai-secondary-banner"
      //     />
      //   ),
    },

    {
      title: "The Result",
      subheading: "The breakthrough: 218 advocates, 600 clicks, 50% conversion",
      info1: `<p>
    The shift was dramatic. Instead of the typical 
    <b>less than 10% attendee-generated content</b> seen at many industry events, 
    African Tech Summit saw:
  </p>
        <br/>
  <ul style='list-style-type:disc; padding-left:28px;margin:0 0 20px 0;display:flex;flex-direction:column;gap:16px;'>

    <li>
      <b>218 attendees</b> actively promoting the event online using Premagic’s event marketing posters
    </li>

    <li>
      <b>Over 600 unique referrals</b> generated directly from those posters, meaning 600 additional sign-ups driven purely through attendee advocacy
    </li>

    <li>
      A <b>50% advocacy rate</b>, 10x higher than the industry average, with an estimated 
      <b>ROI of $4,590</b>
    </li>

  </ul>

  <p>
    Advocacy became a collective effort, not just the work of a few enthusiastic attendees. 
    Nearly half the participant base proudly amplified the event, creating a ripple effect that no paid ad could match.
  </p>`,
      image: (
        <StaticImage
          src="../../images/case-study/african-tech-summit/results.png"
          alt="African Tech Summit advocacy results"
        />
      ),
      imagePosition: "top",
      inlineLink: {
        text: "RETHINKING I-AM-ATTENDING POSTERS FOR SAASBOOMI ANNUAL 2025",
        link: blogUrl("rethinkingAttendingPosters"),
      },
    },

    {
      title: "Why this matters for event organizers",
      image: (
        <StaticImage
          src="../../images/case-study/african-tech-summit/why-this.png"
          alt="Why advocacy matters for event organizers"
        />
      ),
      imagePosition: "top",
      info1: `<p>
    This proves how moving from <b>10%</b> to <b>50%</b> advocacy changes everything.
  </p>
<br/>
  <p><b>Before Premagic:</b></p>

  <p>
    Event organizers were stuck with low advocacy rates, rising marketing costs, and limited visibility beyond the event floor.
  </p>
<br/>
  <p><b>With Premagic:</b></p>

  <p>
    Half of the attendee base became event promoters, organic reach multiplied, and results were trackable in real time.
  </p>
<br/>
  <p>
    It’s not a marginal improvement, it’s a <b>fundamental shift</b> in how events generate visibility and bump up sign-ups.
  </p>
      <br/>
  <p style='text-transform: uppercase;'>
  <b>
    Want to try our 
    <a href='https://premagic.com/create-event-marketing-posters/'>Event Marketing Posters</a> 
    at your event? 
    <a href='https://premagic.com/request-a-demo/'>Get in touch!</a>
    </b>
  </p>`,
    },
    {
      title: "The bottom line",
      info1: `<p>
    African Tech Summit proved that attendee advocacy doesn’t have to be an afterthought. 
    With the right tools, it can become your 
    <b>most effective, authentic, and measurable marketing channel</b>.
  </p>
<br/>
  <p>
    Don’t settle for 10%. Join the organizers who are achieving 
    <b>50% advocacy rates</b> and turning attendees into active promoters.
  </p>
  <br/>

  <p>
    <a href='https://premagic.com/request-a-demo/'>Book a demo</a> today to discover how Premagic can transform your next event.
  </p>
`,
    },
  ],
  // successMetrics: {
  //   title: "Key Success Metrics",
  //   description:
  //     "The platform effectively mobilized the <b>172,566 participants</b> to become active promoters of the event.",
  //   gridValues: [
  //     { id: 1, label: "Poster Shares", value: "16,198" },
  //     { id: 2, label: "Referrals Generated", value: "47,876" },
  //     { id: 3, label: "Ad Spend Saved", value: "$212,262" },
  //     { id: 4, label: "Photo Views", value: "160,531" },
  //     { id: 5, label: "Photo Downloads", value: "2,218" },
  //     { id: 6, label: "Share Rate Increase", value: "94.2%" },
  //     { id: 7, label: "AI Avatars Created", value: "246" },
  //     { id: 8, label: "Ticket Sales Impact", value: "19,907" },
  //   ],
  // },
}

export default africanTechSummit
